var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25002 7.12985C0.697739 7.12984 0.250013 7.57755 0.25 8.12983C0.249987 8.68211 0.697691 9.12984 1.24998 9.12985L1.25002 7.12985ZM23.4571 8.83749C23.8476 8.44698 23.8476 7.81381 23.4571 7.42328L17.0933 1.05917C16.7028 0.668633 16.0696 0.668618 15.6791 1.05913C15.2886 1.44965 15.2886 2.08281 15.6791 2.47335L21.3358 8.13034L15.6788 13.7871C15.2883 14.1776 15.2882 14.8107 15.6788 15.2013C16.0693 15.5918 16.7024 15.5918 17.093 15.2013L23.4571 8.83749ZM1.24998 9.12985L22.75 9.13037L22.75 7.13037L1.25002 7.12985L1.24998 9.12985Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow-white.13a198b6ce52cb003301b0e682eb258c.svg";
export { ForwardRef as ReactComponent };